import "../lifehacks/ArticleFull.css";

const FloripaGuide = () => {

  return (
    <div className="article-full">
      <h2 className="article-subtitle">Путеводитель по острову волшебства</h2>
      <div className="article-section">
        <p className="article-text">
          Флорианополис, или Флорипа, — столица штата Санта-Катарина, расположенная на одноимённом острове в Бразилии. Известный как «Остров волшебства» (Ilha da Magia), он привлекает путешественников своими белоснежными пляжами, живописными лагунами, колониальной архитектурой и яркой культурой. В этой статье мы расскажем о самых интересных местах, которые стоит посетить, чтобы прочувствовать уникальный дух Флорипы.
        </p>
      </div>

      <div className="article-section">
        <h3 className="article-section-title">1. Пляжи Флорипы: от серфинга до семейного отдыха</h3>
        <p className="article-text">
          Флорипа славится более чем 42 пляжами, каждый из которых имеет свою атмосферу. Вот несколько must-visit:
        </p>
        <p className="article-text">
          <strong>Прайя-Моле:</strong> идеально для серферов и тусовок благодаря сильным волнам и surf-клубу Aragua, где можно взять уроки серфинга или йоги. <br />
          <strong>Жоакина:</strong> рай для серферов с дюнами для сэндбординга (около 10 реалов). Здесь проводятся международные соревнования. <br />
          <strong>Журере-Интернасионал:</strong> роскошный пляж, «бразильский Майами», с элитными ресторанами и тёплой водой. <br />
          <strong>Лагоинья-ду-Лесте:</strong> уединённый рай, доступный через 2-часовой трек, с тропическим лесом и пресноводной лагуной.
        </p>
        <div className="article-note">
          <p className="article-note-text">
            Для посещения Лагоинья-ду-Лесте берите воду и перекус, так как инфраструктуры там нет.
          </p>
        </div>
      </div>

      <div className="article-section">
        <h3 className="article-section-title">2. Лагоа-да-Консейсао: ночная жизнь и водные виды спорта</h3>
        <p className="article-text">
          Лагуна Лагоа-да-Консейсао — центр активного отдыха и ночных развлечений. Занимайтесь кайтсерфингом, каякингом или SUP-бордингом, а вечером наслаждайтесь барами и живой музыкой. Попробуйте устрицы в ресторане Ostradamus или прокатитесь на велосипеде вокруг лагуны.
        </p>
      </div>

      <div className="article-section">
        <h3 className="article-section-title">3. Исторический центр и Публичный рынок</h3>
        <p className="article-text">
          Исторический центр Флорипы сочетает колониальную архитектуру и современные веяния. Посетите Метрополитенский собор с витражами и мост Эрсилиу-Луз, особенно красивый ночью. На Публичном рынке (Mercado Público) попробуйте пастелитос с моллюсками и купите ремесленные сувениры.
        </p>
      </div>

      <div className="article-section">
        <h3 className="article-section-title">4. Колониальные деревни</h3>
        <p className="article-text">
          Санту-Антониу-де-Лисбоа славится закатами и морепродуктами, а Рибейрао-да-Илья — устрицами и рыбацкой атмосферой. Посетите их во второй половине дня для ужина с видом на океан.
        </p>
        <p className="article-section-info">
          Эти деревни основаны азорскими переселенцами более 250 лет назад.
        </p>
      </div>

      <div className="article-section">
        <h3 className="article-section-title">5. Остров Кампече</h3>
        <p className="article-text">
          Остров Кампече — археологический заповедник с кристальной водой, напоминающей Карибы. Занимайтесь сноркелингом, гуляйте по тропам или изучайте петроглифы. Доступ на лодке, визит ограничен 1,5 часами.
        </p>
        <div className="article-note">
          <p className="article-note-text">
            Бронируйте поездку на Кампече заранее из-за ограниченного времени посещения.
          </p>
        </div>
      </div>

      <div className="article-section">
        <h3 className="article-section-title">6. Природные достопримечательности</h3>
        <p className="article-text">
          <strong>Водопад Пери:</strong> лагуна с водопадом для купания и походов. <br />
          <strong>Дюны Жоакина:</strong> предлагают сэндбординг. <br />
          <strong>Параглайдинг:</strong> над лагунами — адреналин. <br />
          <strong>Тропа Trilha Do Dolmén Da Oração:</strong> подарит панорамные виды.
        </p>
      </div>

      <div className="article-section">
        <h3 className="article-section-title">7. Культура и гастрономия</h3>
        <p className="article-text">
          Флорипа — город гастрономии ЮНЕСКО. Попробуйте устрицы в Bar do Arante, асаи в Açailand и блюда на карнавале с шоу Boi de Mamão. Для шопинга посетите Beiramar или магазины в Лагоа-да-Консейсао.
        </p>
      </div>

      <div className="article-section">
        <h3 className="article-section-title">8. Форталезы</h3>
        <p className="article-text">
          Крепости Сан-Жозе-да-Понта-Гросса и Санта-Барбара-да-Вила расскажут о колониальном прошлом. Дом Альфандеги — место для покупки ремесленных сувениров от 400 мастеров.
        </p>
      </div>

      <div className="article-section">
        <h3 className="article-section-title">Практические советы</h3>
        <p className="article-text">
          <strong>Лучшее время для посещения:</strong> декабрь–март (лето), но бронируйте заранее. <br />
          <strong>Аэропорт:</strong> Эрсилиу-Луз (FLN) принимает рейсы из крупных городов. <br />
          <strong>Язык:</strong> выучите базовые фразы на португальском, так как английский редок. <br />
          <strong>Валюта:</strong> используйте бразильский реал (BRL), носите наличные для рынков. <br />
          <strong>Безопасность:</strong> Флорипа безопасна, но соблюдайте осторожность.
        </p>
      </div>
    </div>
  );
};

export default FloripaGuide;